import { ModalContainer, ModalContent, ModalFooter } from './components';

export const ModalNew = {
  Container: ModalContainer,
  Footer: ModalFooter,
  Content: ModalContent,
};
